import { InputBase } from '@shared/forms/inputs/input-base.class';
import { CheckboxInput } from '@shared/forms/inputs/input-checkbox.class';
import { EventsEmailUnsubscribeModel } from '@store/user/user.interface';

export const transformEventsEmailUnsubscriptions = (
  unsubscriptions: EventsEmailUnsubscribeModel[]
): InputBase<any>[] => {
  const inputBase: any = {
    key: 'unsubscriptions',
    label: '',
    order: 1,
    required: false,
    translate: false,
    value: true,
    options: [],
    cssClass: ''
  };

  unsubscriptions.slice(0).forEach((unsubscription) => {
    inputBase.options.push({
      key: unsubscription.id,
      label: unsubscription.eventName,
      value: true,
      required: false,
      cssClass: '',
      columns: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      }
    });
  });

  return [new CheckboxInput(inputBase)];
};
